// NotificationContext.js
'use client';
import React, { createContext, useContext, useState } from 'react';

const initialNotificationState = {
  notification: '',
  showNotification: (message: string) => {},
  isSimilarItemVisible: undefined,
  setIsSimilarItemVisible: (isVisible: any) => {},
};

const NotificationContext = createContext(initialNotificationState);

export const NotificationProvider = ({ children }: any) => {
  const [notification, setNotification] = useState('');
  const [isSimilarItemVisible, setIsSimilarItemVisible] = useState(undefined);
  const showNotification = (message: string) => {
    setNotification(message);
  };

  return (
    <NotificationContext.Provider
      value={{ notification, showNotification, isSimilarItemVisible, setIsSimilarItemVisible }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
